import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const ListFilter: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M3 6h18' }],
    ['path', { d: 'M7 12h10' }],
    ['path', { d: 'M10 18h4' }],
  ],
];

export default ListFilter;
